import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { WizardComponent } from 'angular-archwizard';
import { ImplementerSnapshotSummary } from '../../../../models/implementer/implementer.models';
import { ImplementerMergeWizardStepTwoComponent } from '../implementer-merge-wizard-step-two/implementer-merge-wizard-step-two';
import { ImplementerMergeWizardStepThreeComponent } from '../implementer-merge-wizard-step-three/implementer-merge-wizard-step-three';

@Component({
  selector: 'implementer-merge-wizard-component',
  templateUrl: './implementer-merge-wizard.component.html',
})
export class ImplementerMergeWizardComponent implements OnInit {
  @ViewChild(WizardComponent) private wizard: WizardComponent;
  @ViewChild(ImplementerMergeWizardStepTwoComponent) private stepTwo: ImplementerMergeWizardStepTwoComponent;
  @ViewChild(ImplementerMergeWizardStepThreeComponent) private stepThree: ImplementerMergeWizardStepThreeComponent;

  @Input() snapshotSummary: ImplementerSnapshotSummary;

  @Output() goBackClicked: EventEmitter<void> = new EventEmitter();

  public isLoaded: boolean;

  constructor() {
  }

  ngOnInit() {
    this.isLoaded = true;
  }

  onFirstStepNext(): void {
    this.wizard.goToNextStep();
  }

  onSecondStepNext(): void {
    this.wizard.goToNextStep();
  }

  onStepTwoEnter() {
    this.stepTwo.onStepEnter();
  }

  onStepThreeEnter() {
    this.stepThree.stepInitialLoad();
  }

  // Hooking into review previous step click
  onCompleteStepPreviousStepClick() {
    this.wizard.goToPreviousStep();
  }

  onReviewStepPreviousStepClick() {
    this.wizard.goToPreviousStep();
  }
}



// WEBPACK FOOTER //
// ./src/pages/implementer/implementer-merge/implementer-merge-wizard/implementer-merge-wizard.component.ts